import { useEffect } from "react";
import { UpdateColumns, useUpdatesColumns } from "./columns";
import DataTable from "./data-table";
import { useSelector } from "react-redux";
import {
  dataUpdatesSelector,
  clientSelector,
} from "@/redux/clients/clients.selector";
import { getDataUpdates } from "@/redux/clients/clients.action";
import { useAppDispatch } from "@/redux/hooks";
import { TableSkeleton } from "@/components/ui/loading";

const UpdatesTablePage = () => {
  const dispatch = useAppDispatch();
  const dataUpdates = useSelector(dataUpdatesSelector);
  const { loading } = useSelector(clientSelector).ui;

  const columns = useUpdatesColumns();

  useEffect(() => {
    dispatch(getDataUpdates());
  }, [dispatch]);

  const data =
    (dataUpdates &&
      dataUpdates.map((update) => ({
        processedDate: update.processedDate,
        fileName: update.fileName,
        batchId: update.batchId,
        fileType: update.fileType,
      }))) ||
    [];

  return (
    <div className="container pb-10 min-w-full overflow-y-auto">
      {loading ? (
        <TableSkeleton rows={10} columns={4} />
      ) : (
        <DataTable columns={columns} data={data as UpdateColumns[]} />
      )}
    </div>
  );
};

export default UpdatesTablePage;
